import { SettingsTypes } from '@powerplay/settings';
export class FpsManager {
    settings;
    fpsLimit;
    skipValueLast = 0;
    animationsLock30 = false;
    animationsPerformanceLock30 = false;
    active = false;
    fpsData = [];
    frameCounter = 0;
    lastFpsValuesForAutoQuality = [];
    qualityOnStart = 0;
    SKIP_LIMIT = 0;
    CHECK_FRAME_LOG = 3;
    CHECK_FRAME_AUTO_QUALITY = 60;
    FIRST_FRAMES_NOT_CHECKED = 60;
    FPS_LIMITS_AUTO_CHANGE = [20, 20, 25, 25, 25, 28, 30, 35, 40];
    FPS_RAISE_QUALITY_BY_ONE = 28;
    FPS_RAISE_QUALITY_BY_TWO = 57;
    CHECK_AUTO_FPS_VALUES_COUNT = 20;
    constructor(settings, fpsLimit) {
        this.settings = settings;
        this.fpsLimit = fpsLimit;
    }
    init() {
        this.SKIP_LIMIT = 1000 / this.fpsLimit;
        this.skipValueLast = Date.now();
        this.FPS_LIMITS_AUTO_CHANGE.forEach((_, key) => {
            this.fpsData[key] = {
                count: 0,
                min: 999,
                sum: 0,
                actualFps: 0
            };
        });
        this.qualityOnStart = this.settings.getSetting(SettingsTypes.quality);
    }
    reset() {
        this.pauseCounting();
        this.init();
        this.frameCounter = 0;
    }
    checkSkip() {
        const now = Date.now();
        const elapsed = now - this.skipValueLast;
        let result = false;
        if (elapsed > this.SKIP_LIMIT) {
            this.skipValueLast = now - (elapsed % this.SKIP_LIMIT);
        }
        else {
            result = true;
        }
        return result;
    }
    update(pausedGame, actualFps) {
        if (!this.active || pausedGame)
            return;
        this.frameCounter += 1;
        if (this.frameCounter > this.FIRST_FRAMES_NOT_CHECKED &&
            this.frameCounter % this.CHECK_FRAME_LOG === 0) {
            const quality = this.settings.getSetting(SettingsTypes.quality);
            this.fpsData[quality].count++;
            this.fpsData[quality].sum += actualFps;
            this.fpsData[quality].actualFps = actualFps;
            this.lastFpsValuesForAutoQuality.push(actualFps);
            if (this.lastFpsValuesForAutoQuality.length > this.CHECK_AUTO_FPS_VALUES_COUNT) {
                this.lastFpsValuesForAutoQuality.shift();
            }
            if (this.fpsData[quality].min > actualFps) {
                this.fpsData[quality].min = actualFps;
            }
        }
        this.checkAutoQuality();
    }
    checkAutoQuality() {
        const quality = this.settings.getSetting(SettingsTypes.quality);
        const qualityAuto = this.settings.getSetting(SettingsTypes.qualityAuto);
        if (qualityAuto !== 1 || this.frameCounter % this.CHECK_FRAME_AUTO_QUALITY !== 0)
            return;
        const averageFPS = this.getActualAverageFps();
        if (averageFPS === -1 ||
            quality === 0 ||
            averageFPS > this.FPS_LIMITS_AUTO_CHANGE[quality])
            return;
        let newQuality = quality - 1;
        const avgFpsToDescreaseQuality = 0.75 * this.FPS_LIMITS_AUTO_CHANGE[quality];
        if (newQuality > 0 && averageFPS <= avgFpsToDescreaseQuality)
            newQuality -= 1;
        console.log(`kvalita bola ${quality} a avg ${averageFPS} z ${this.FPS_LIMITS_AUTO_CHANGE[quality]}`);
        this.settings.update(SettingsTypes.quality, newQuality);
        console.log(`aka je nova kvalita? ${this.settings.getSetting(SettingsTypes.quality)}`);
        this.lastFpsValuesForAutoQuality = [];
    }
    startCounting() {
        this.active = true;
    }
    pauseCounting() {
        this.active = false;
    }
    getMinimalFpsByQuality(quality) {
        return this.fpsData[quality].min;
    }
    getAverageFpsByQuality(quality) {
        if (this.fpsData[quality].count === 0)
            return 0;
        return Math.round(this.fpsData[quality].sum / this.fpsData[quality].count);
    }
    getActualAverageFps() {
        const count = this.lastFpsValuesForAutoQuality.length;
        if (count < this.CHECK_AUTO_FPS_VALUES_COUNT)
            return -1;
        return Math.round(this.lastFpsValuesForAutoQuality.reduce((acc, val) => (acc += val), 0) / count);
    }
    getActualFpsByQuality(quality) {
        if (this.fpsData[quality].count === 0)
            return 0;
        return Math.round(this.fpsData[quality].actualFps);
    }
    checkRaiseQuality() {
        const maxQuality = this.FPS_LIMITS_AUTO_CHANGE.length - 1;
        const quality = this.settings.getSetting(SettingsTypes.quality);
        if (!this.settings.getSetting(SettingsTypes.qualityAuto) || quality === maxQuality)
            return;
        const averageFps = this.getAverageFpsByQuality(quality);
        let raiseQuality = 0;
        if (averageFps >= this.FPS_RAISE_QUALITY_BY_ONE)
            raiseQuality = 1;
        if (averageFps >= this.FPS_RAISE_QUALITY_BY_TWO &&
            quality > this.qualityOnStart - 2) {
            raiseQuality = 2;
        }
        if (!raiseQuality)
            return;
        let newQuality = quality + raiseQuality;
        if (newQuality > maxQuality)
            newQuality = maxQuality;
        this.settings.update(SettingsTypes.quality, newQuality);
    }
}
//# sourceMappingURL=FpsManager.js.map